<template>
    <b-input-group size="sm">
        <b-input-group-prepend is-text>
            <i class="fas fa-search" aria-hidden="true"></i>
        </b-input-group-prepend>
        <b-form-input
            ref="input"
            :value="value"
            type="search"
            :placeholder="placeholder"
            :aria-label="ariaLabel"
            @input="$emit('input', $event)"
            @keydown.enter.prevent="navigate($event.shiftKey ? -1 : 1)"
        ></b-form-input>
        <b-input-group-append v-if="active">
            <span
                class="input-group-text employee-workforce-search__count"
                aria-live="polite"
            >
                {{ positionLabel }}
            </span>
            <b-button
                variant="outline-secondary"
                :disabled="!resultCount"
                title="Предыдущий результат (Shift + Enter)"
                aria-label="Предыдущий результат поиска"
                @click="navigate(-1)"
            >
                <i class="fas fa-chevron-up" aria-hidden="true"></i>
            </b-button>
            <b-button
                variant="outline-secondary"
                :disabled="!resultCount"
                title="Следующий результат (Enter)"
                aria-label="Следующий результат поиска"
                @click="navigate(1)"
            >
                <i class="fas fa-chevron-down" aria-hidden="true"></i>
            </b-button>
            <b-button
                variant="outline-secondary"
                title="Очистить поиск"
                aria-label="Очистить поиск"
                @click="clear"
            >
                <i class="fas fa-times" aria-hidden="true"></i>
            </b-button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
export default {
    name: 'EmployeeWorkforceSearch',
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Найти сотрудника'
        },
        ariaLabel: {
            type: String,
            default: 'Поиск сотрудников'
        },
        resultCount: {
            type: Number,
            default: 0
        },
        positionLabel: {
            type: String,
            default: '0/0'
        }
    },
    computed: {
        active() {
            return Boolean(String(this.value || '').trim());
        }
    },
    methods: {
        navigate(direction) {
            if (!this.active || !this.resultCount) return;
            this.$emit('navigate', direction);
        },
        clear() {
            this.$emit('input', '');
            this.$nextTick(this.focus);
        },
        focus() {
            const input = this.$refs.input;
            if (input && typeof input.focus === 'function') input.focus();
        }
    }
};
</script>

<style scoped>
.employee-workforce-search__count {
    min-width: 50px;
    justify-content: center;
    padding-right: 0.45rem;
    padding-left: 0.45rem;
    background: #fff;
    color: #495057;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
}

.input-group-append .btn {
    min-width: 34px;
    padding-right: 0.45rem;
    padding-left: 0.45rem;
}

.form-control,
.btn {
    touch-action: pan-y;
}

@media (max-width: 767.98px) {
    .btn {
        min-height: 30px;
        padding: 4px 7px;
        font-size: 0.68rem;
    }
}
</style>
